import { useId } from "react";

import { Field, errorInputStyle, inputStyle } from "./Field";

interface TextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  placeholder?: string;
  helper?: React.ReactNode;
  error?: string | null;
  type?: "text" | "url" | "email";
  autoComplete?: string;
  disabled?: boolean;
}

export function TextField({
  label,
  value,
  onChange,
  required,
  placeholder,
  helper,
  error,
  type = "text",
  autoComplete,
  disabled,
}: TextFieldProps) {
  const id = useId();
  return (
    <Field label={label} htmlFor={id} required={required} helper={helper} error={error}>
      <input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        style={error ? errorInputStyle : inputStyle}
      />
    </Field>
  );
}
